<template>
  <div class="item-main">
    <div
      class="form"
      :style="{ 'flex-direction': !isDesktop && 'column', 'margin-top': 0 }"
    >
      <ActivitySelector
        v-model:value="query.activityId"
        @change="getData"
      ></ActivitySelector>
      <LastXDays
        :style="{
          'margin-top': !isDesktop && '8px',
        }"
        :daysList="[1, 7, 30]"
        v-model:value="query.time"
        @get-data="getData"
      ></LastXDays>
    </div>
    <a-spin :spinning="spinning">
      <a-row class="data" :gutter="10">
        <a-col :md="6" :span="12">
          <div class="data-item blue-shadow">
            <div class="data-item-title">Clicks</div>
            <div class="data-item-data">{{ clickNumber }}</div>
          </div>
        </a-col>
        <a-col :md="6" :span="12">
          <div class="data-item  yellow-shadow">
            <div class="data-item-title">New Registrations</div>
            <div class="data-item-data">{{ newRegistrations }}</div>
          </div>
        </a-col>
        <a-col :md="6" :span="12">
          <div class="data-item  blue-shadow">
            <div class="data-item-title">New Real Traders</div>
            <div class="data-item-data">{{ newRealTraders }}</div>
          </div>
        </a-col>
        <a-col :md="6" :span="12">
          <div class="data-item  yellow-shadow">
            <div class="data-item-title">Qualified Real Traders</div>
            <div class="data-item-data">{{ qualifiedRealTraders }}</div>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import ActivitySelector from '@/components/ActivitySelector'
import LastXDays from '@/components/LastXDays'

export default {
  name: 'NumberData',
  components: { ActivitySelector, LastXDays },
  mounted() {
    const id = this.$store.state.link.defaultActivityId
    if (id) {
      this.query.activityId = id
      this.getData()
    }
  },
  computed: {
    defaultActivityId() {
      return this.$store.state.link.defaultActivityId
    },
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  watch: {
    defaultActivityId() {
      this.query.activityId = this.defaultActivityId
      this.getData()
    },
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  data() {
    return {
      query: {
        activityId: undefined,
        time: 1,
      },
      clickNumber: 0,
      newRegistrations: 0,
      newRealTraders: 0,
      qualifiedRealTraders: 0,
      spinning: false,
    }
  },
  methods: {
    getData() {
      if (!this.query.activityId) return
      this.spinning = !this.spinning
      this.$store
        .dispatch('statistics/GetAllOfActivity', this.query)
        .then((res) => {
          this.clickNumber = res[0]
          this.newRegistrations = res[1]
          this.newRealTraders = res[2]
          this.qualifiedRealTraders = res[3]
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.data {
  margin-top: 20px;
  // display: flex;
  // justify-content: space-between;

  .data-item {
    // width: 220px;
    height: 100px;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 10px;

    .data-item-title {
      font-weight: 400;
      color: #330000;
      line-height: 20px;
      font-size: 14px;
    }
    .data-item-data {
      font-size: 30px;
      font-weight: 400;
      color: #330000;
      line-height: 40px;
    }
  }
  .blue-shadow {
    box-shadow: 0px 0px 10px 0px rgba(110, 184, 251, 0.5);
    border-bottom: 4px #48b8fd solid;
  }
  .yellow-shadow {
    box-shadow: 0px 0px 10px 0px rgba(110, 184, 251, 0.5);
    border-bottom: 4px #fdcb48 solid;
  }
}
</style>
